import React from 'react';
import PageHeader from './global-components/page-header';
import CategoryPosts from './section-components/category-posts';
import { useParams } from 'react-router-dom';

const CategoryPage = () => {
    const { slug } = useParams();

    return (
        <div>
            <PageHeader headertitle="Category" />
            <CategoryPosts categorySlug={slug} />
        </div>
    );
};

export default CategoryPage;
